/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component } from 'react';
import './more-menu.css';
import { withRouter } from 'react-router-dom';
import { MORE_MENU_SCREEN, COMMON } from '../../global/Constants';
import Utilities from '../../global/Utilities';
import ApiServices from '../../providers/ApiServices';


const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");

class ChangePasswordPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            errorMsg: '',
            loading: false,
            setPasswordShown1: false,
            setPasswordShown2: false,
            setPasswordShown3: false,
            fields: {
                password1: "",
                password2: "",
                password3: ""
            }
        }
    }

    componentDidMount() {
        document.getElementById("update").disabled = true;
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || (typeof value === 'undefined')) {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields })
        const password1 = this._getFieldValue("password1", "");
        const password2 = this._getFieldValue("password2", "");
        const password3 = this._getFieldValue("password3", "");
        document.getElementById("update").disabled = (password1.length === 0 || password2.length < 8 || password3.length < 8);

        let message = '';
        if (!strongRegex.test(password2) && password2.length < 21) {
            message = 'Password must be 8 to 20 character, It includes contain at least 1 lowercase, 1 uppercase, 1 numeric character.'
            document.getElementById("update").disabled = true;
        } else {
            message = '';
            document.getElementById("update").enabled = false;
        }

        this.setState({
            errorMsg: message
        });

        // if (7 < password1.length && password1.length < 21) {
        //     this.setState({
        //         errorMsg: "Password must be 8 to 20 character"
        //     });
        // } else {
        //     this.setState({
        //         errorMsg: ""
        //     });
        // }
    }

    _performChangePassword = (e) => {
        this.props.loaderCallback(true);
        e.preventDefault();

        const password2 = this._getFieldValue("password2", "");
        const password3 = this._getFieldValue("password3", "");
        var body = JSON.stringify({
            newPassword: password2,
            confirmPassword: password3,
        });

        try {
            ApiServices.changePassword(body)
                .then(response => {
                    this.props.loaderCallback(false);
                    var status = response.success;
                    if (status) {
                        alert(response.message)
                        this.props._sendToParent(false);

                    } else {
                        Utilities.LogPrint("Status", response.message);
                        if (response.message !== undefined && response.message) {
                            this.setState({
                                errorMsg: response.message
                            });
                        }
                    }
                }).catch(error => {
                    this.props.loaderCallback(false);
                    this.setState({ errorMsg: error });
                });
        } catch (error) {
            this.props.loaderCallback(false);
            this.setState({ errorMsg: error });
        }
    }

    _handleUpdate = (e) => {
        e.preventDefault();
        const password3 = this._getFieldValue("password3", "");
        const password2 = this._getFieldValue("password2", "");
        if (password3 === password2) {
            this._performChangePassword(e);
        } else {
            this.setState({
                errorMsg: "Confirm Passwords does not match"
            });
        }
    }

    _togglePasswordVisiblity1 = () => {
        this.setState({ setPasswordShown1: !this.state.setPasswordShown1 });
    };

    _togglePasswordVisiblity2 = () => {
        this.setState({ setPasswordShown2: !this.state.setPasswordShown2 });
    };

    _togglePasswordVisiblity3 = () => {
        this.setState({ setPasswordShown3: !this.state.setPasswordShown3 });
    };

    render() {
        const { isActive } = this.props;
        const { setPasswordShown1, setPasswordShown2, setPasswordShown3, errorMsg } = this.state;
        const password1 = this._getFieldValue("password1", "");
        const password2 = this._getFieldValue("password2", "");
        const password3 = this._getFieldValue("password3", "");
        return (
            <div id="changePassword" className={isActive ? "more-menu-body" : "more-menu-body d-none"}>
                <div className="row">
                    <div className="col-12">
                        <h6 className="mb-3"><a className="more-menu-back" onClick={() => { this.props._sendToParent(false) }}> <i className="customic ic-back-button"></i> </a>{MORE_MENU_SCREEN.CHANGE_PASSWORD}</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="form-group pass-hide-show">
                            <label className="font-weight-medium">{COMMON.CURRENT_PASSWORD}</label>
                            <div className="col-12 p-0">
                                <input type={setPasswordShown1 ? "text" : "password"} className="form-control" placeholder="" onChange={this._handleValueChange.bind(this, "password1")} value={password1} maxLength={21} />
                                <i className={setPasswordShown1 ? "customic ic-eye" : "customic ic-eye-hide"} onClick={this._togglePasswordVisiblity1} ></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-lg-6 mt-3">
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group pass-hide-show">
                                    <label className="font-weight-medium">{COMMON.NEW_PASSWORD}</label>
                                    <div className="col-12 p-0">
                                        <input type={setPasswordShown2 ? "text" : "password"} className="form-control" placeholder="" onChange={this._handleValueChange.bind(this, "password2")} value={password2} maxLength={21} />
                                        <i className={setPasswordShown2 ? "customic ic-eye" : "customic ic-eye-hide"} onClick={this._togglePasswordVisiblity2} ></i>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group pass-hide-show">
                                    <label className="font-weight-medium">{COMMON.CONFIRM_NEW_PASSWORD}</label>
                                    <div className="col-12 p-0">
                                        <input type={setPasswordShown3 ? "text" : "password"} className="form-control" placeholder="" onChange={this._handleValueChange.bind(this, "password3")} value={password3} maxLength={21} />
                                        <i className={setPasswordShown3 ? "customic ic-eye" : "customic ic-eye-hide"} onClick={this._togglePasswordVisiblity3} ></i>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <span
                                    className={
                                        errorMsg.length > 0 ? "error-msg" : "d-none error-msg"
                                    }
                                >
                                    {errorMsg}
                                </span>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 d-flex button-grp-bottom mt-md-4">
                        <button className="btn btn-secondary w-50 mr-2 more-menu-back" onClick={() => { this.props._sendToParent(false) }}>{COMMON.CANCEL}</button>
                        <button id="update" className="btn btn-primary w-50" onClick={this._handleUpdate} >{COMMON.UPDATE}</button>
                    </div>
                </div>
            </div>

        );
    }
}

export default withRouter(ChangePasswordPage)